import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { MARKET } from '@/common/constants/markets';
import { ROUTES } from '@/common/constants/routes';
import { useMarket } from '@/common/hooks/useMarket';
import { useGetInsurancePolicies } from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { usePageViewTracking } from '@/web/hooks/usePageViewTracking';
import { Redirect } from 'expo-router';
import { ESInsuranceHome } from './ESInsuranceHome';
import { PTInsuranceHome } from './PTInsuranceHome';

export function InsuranceHomePage() {
  const { slug } = useMarket();
  const { policies, upcomingPolicy, isInitialLoading } =
    useGetInsurancePolicies();
  usePageViewTracking('insurance_page');

  if (isInitialLoading) {
    return <LoadingPlaceholder />;
  }

  if (policies?.length === 0 && !upcomingPolicy) {
    return <Redirect href={ROUTES.ROOT} />;
  }

  const activePolicy = policies?.find(
    (policy) => policy.product?.plan?.type === 'health'
  );

  switch (slug) {
    case MARKET.PT:
      return (
        <PTInsuranceHome
          activePolicy={activePolicy}
          upcomingPolicy={upcomingPolicy}
        />
      );
    case MARKET.ES:
      return (
        <ESInsuranceHome
          activePolicy={activePolicy}
          upcomingPolicy={upcomingPolicy}
        />
      );
    default:
      return <Redirect href={ROUTES.NOT_FOUND} />;
  }
}
